import { render, staticRenderFns } from "./EmailMessages.vue?vue&type=template&id=7d9d36d8&scoped=true"
import script from "./EmailMessages.vue?vue&type=script&lang=js"
export * from "./EmailMessages.vue?vue&type=script&lang=js"
import style0 from "./EmailMessages.vue?vue&type=style&index=0&id=7d9d36d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9d36d8",
  null
  
)

export default component.exports